import { Reducer } from "redux";

import {
    ARTICLE_SEARCH_FETCH_FAILURE,
    ARTICLE_SEARCH_FETCH_REQUEST,
    ARTICLE_SEARCH_FETCH_SUCCESS,
    ArticleSearchFetchFailureAction,
    ArticleSearchFetchRequestAction,
    ArticleSearchFetchSuccessAction,
} from "@/mk2/apps/wiki/containers/ArticleSearch/ArticleSearch.actions";
import { tupdate } from "@/mk2/helpers/types";
import infiniteList, {
    State as InfiniteListState,
    initialState as initialInfiniteListState,
} from "@/mk2/reducers/infiniteList";

const articleSearchInfiniteListReducer = infiniteList<
    ArticleSearchFetchRequestAction,
    ArticleSearchFetchSuccessAction,
    ArticleSearchFetchFailureAction
>("WIKI_ARTICLE_SEARCH_FETCH", (a) => a.response.result.articles);

export interface ArticleSearchByQueryState extends InfiniteListState {
    resultsCount: number;
}

export const initialArticleSearchByQueryState: ArticleSearchByQueryState = {
    ...initialInfiniteListState,
    resultsCount: 0,
};

declare type ArticleSearchReducerActions =
    | ArticleSearchFetchRequestAction
    | ArticleSearchFetchSuccessAction
    | ArticleSearchFetchFailureAction;

const ArticleSearchByQueryReducer: Reducer<
    ArticleSearchByQueryState,
    ArticleSearchReducerActions
> = (state = initialArticleSearchByQueryState, action) => {
    switch (action.type) {
        case ARTICLE_SEARCH_FETCH_REQUEST:
        case ARTICLE_SEARCH_FETCH_FAILURE:
            return {
                ...state,
                ...articleSearchInfiniteListReducer(state, action),
            };

        case ARTICLE_SEARCH_FETCH_SUCCESS:
            return {
                ...state,
                ...articleSearchInfiniteListReducer(state, action),
                resultsCount: action.resultsCount,
            };

        default:
            return state;
    }
};

interface ByQueryState {
    [query: string]: ArticleSearchByQueryState;
}

export interface ArticleSearchPageState {
    search: ByQueryState;
}

export const initialArticleSearchPageState: ArticleSearchPageState = {
    search: {},
};

export const getQueryKey = (categorySlug: string, articleSlug: string, query: string) =>
    `${categorySlug}/${articleSlug}/${query}`;

export const reducer: Reducer<ArticleSearchPageState, ArticleSearchReducerActions> = (
    state = initialArticleSearchPageState,
    action,
) => {
    const key = getQueryKey(action.categorySlug, action.articleSlug, action.query);
    switch (action.type) {
        case ARTICLE_SEARCH_FETCH_REQUEST:
        case ARTICLE_SEARCH_FETCH_FAILURE:
            return tupdate(state, {
                search: tupdate(state.search, {
                    [key]: ArticleSearchByQueryReducer(state.search[key], action),
                }),
            });

        case ARTICLE_SEARCH_FETCH_SUCCESS:
            return tupdate(state, {
                search: tupdate(state.search, {
                    [key]: ArticleSearchByQueryReducer(state.search[key], action),
                }),
            });

        default:
            return state;
    }
};

export default reducer;
